import React, { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";

import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Table } from 'react-bootstrap';
// import TrashIcon from '../../images/TrashIcon.png';
import { authKey, SES_LIST_FOR_APPROVAL, BULK_APPROVE_SES, GET_STAKEHOLDER_CATEGORY, GET_USER_DETAILS, SEND_SES_TO_SAP, DOWNLOAD_DOCUMENT } from '../../../common/URLs';
import jwt from 'jwt-decode';
//import { CommonRegistrationSidebar } from "../../../common/common-registration-sidebar/commonRegistrationSidebar";
import SearchIcon from "@mui/icons-material/Search";
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
// import './sesList.css';
import { CommonInnerSidebar } from '../../../common/common-inner-sidebar/commonInnerSidebar';
import moment from 'moment';
import { Button, Box, Card, Tooltip, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab, CardContent, Link } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { CheckBox } from "@mui/icons-material";
import { DialogContent, Dialog, DialogActions } from '@mui/material';
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { ErrorPopover } from '../../../common/ErrorPopover/errorPopover';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from "../../../common/constants";
import { Clear as CancelIcon, Done as ApproveIcon, Send as SendIcon } from '@mui/icons-material';
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { useTranslation } from "react-i18next";
import { ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";

function SESApproval() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [accountName, setAccountName] = useState();
  const [asnDetails, setAsnDetails] = useState([]);
  const [selected, setSelected] = useState(asnDetails);
  const [searchFilter, setSearchFilter] = useState({
    "consignmentNo": "",
    "grnDate": "",
    // "materialtype":""
  });
  const [errorMessage, setErrorMessage] = useState({
    noRecordError: '',
  });
  const decoded = jwt(getLocalStorageItem('id_token'));
  const [stakeholderDetails, setStakeholderDetails] = useState();
  const [grnListData, setSesListData] = useState();
  const [bulkApproveSes, setBulkApproveSes] = useState();

  // const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalOpen1 = () => setLogModalOpen(true);

  const [logModalOpen, setLogModalOpen] = useState(false);
  const [logModalOpen2, setLogModalOpen2] = useState(false);
  const handleLogModalOpen2 = () => setLogModalOpen2(true);
  const handleLogModalClose2 = () => { setLogModalOpen2(false); getSesList(); }
  const [sesList, setsesList] = useState([]);
  const [open, setOpen] = React.useState(false);

  const [tabValue, setTabValue] = useState(state?.tabValue ? state?.tabValue : "false");

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const [confirmSapOpen, setConfirmSapOpen] = useState(false);
  const handleConfirmSapOpen = () => setConfirmSapOpen(true);
  const handleConfirmSapClose = () => setConfirmSapOpen(false);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setsesList([]);
  }

  useEffect(() => {
    getUserDetails();
  }, []);

  function getUserDetails() {
    apiClient
      .post(GET_USER_DETAILS,
        {
          "emailAddress": localStorage.getItem('InspectorEmail')
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setAccountName(response.data.user.firstname + " " + response.data.user.middlename + " " + response.data.user.lastname)
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    if (decoded.extension_URN) {
      getStakeDetails();
    }
  }, [decoded.extension_URN]);

  function getStakeDetails() {
    loaderService.showLoader()
    apiClient
      .post(GET_STAKEHOLDER_CATEGORY,
        {
          "urn": decoded.extension_URN,
          "type": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setStakeholderDetails(response.data);
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()
        toast.error(error.message);
      });
  }

  useEffect(() => {
    getSesList();
  }, [tabValue]);

  function getSesList() {
    loaderService.showLoader();

    let isApprovedFlag = "";
    let isSapSesAddedFlag = "";

    switch (tabValue) {
      case "false":
        isApprovedFlag = "false";
        isSapSesAddedFlag = "";
        break;
      case "true":
        isApprovedFlag = "true";
        isSapSesAddedFlag = "";
        break;
      case "ready_sap":
        isApprovedFlag = "true";
        isSapSesAddedFlag = "false";
        break;
      case "sent_sap":
        isApprovedFlag = "true";
        isSapSesAddedFlag = "true";
        break;
      default:
        isApprovedFlag = "false";
        isSapSesAddedFlag = "";
    }

    apiClient
      .post(SES_LIST_FOR_APPROVAL,
        {
          "isApproved": isApprovedFlag,
          "stakeholderUrn": decoded.extension_URN ? decoded.extension_URN : "",
          "isSapSesAdded": isSapSesAddedFlag
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setSesListData(response.data.sesApprovalList);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const handleChange = (e) => {
    if (e.target.name === "consignmentNo" || e.target.name === "sesDate") {
      setSearchFilter({ ...searchFilter, [e.target.name]: e.target.value })
    }
  }

  const onViewDetails = (cellValues) => {
    navigate('./sesDetailsScreen', {
      state: { selectedRow: cellValues.row }
    });
  }

  const columns = [
    { field: 'sesNo', headerName: 'SES No', width: 120 },
    { field: 'invoiceNo', headerName: 'Invoice No', width: 120 },
    { field: 'sesStakeholderType', headerName: 'SES Stakeholder Type', width: 170 },
    { field: 'sesType', headerName: 'Material Type', width: 150 },
    {
      field: 'sesDate', headerName: 'SES Date', width: 120,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    { field: 'sesQuantity', headerName: 'SES Quantity (MT)', width: 140 },
    {
      field: 'invoiceAmount', headerName: 'SES Amount(in Rs)', width: 150,
      valueGetter: (params) => {
        return Number(params?.value).toFixed(4);

      }
      // valueFormatter: () => "MT"
    },
    { field: 'poNumber', headerName: 'PO Number', width: 160 },
    { field: 'sapPoNumber', headerName: 'SAP Po Number', width: 160 },
    {
      field: 'invoiceDocuments',
      headerName: "Invoice Documents",
      width: 260,
      renderCell: (params) => {
        const docs = params.value || [];
        if (!docs || docs.length === 0) return <Typography variant="caption">No Documents</Typography>;
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, py: 0.5 }}>
            {docs.map((doc, idx) => (
              <Box key={doc.invoiceFileId || idx} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Link
                  component="button"
                  variant="body2"
                  onClick={(e) => {
                    e.preventDefault();
                    viewdownloadDocument(doc?.invoiceFileId, doc?.invoiceFileName, "View");
                  }}
                  underline="hover"
                  sx={{ cursor: 'pointer', fontSize: '0.8rem' }}
                >
                  {doc.invoiceFileName}
                </Link>
                <Button
                  size="small"
                  variant="text"
                  onClick={() => viewdownloadDocument(doc?.invoiceFileId, doc?.invoiceFileName, "Download")}
                  sx={{ minWidth: 'auto', p: 0, fontSize: '0.7rem', textTransform: 'none' }}
                >
                  Download
                </Button>
              </Box>
            ))}
          </Box>
        );
      }
    },
    {
      field: 'Action', width: 100,
      renderCell: (cellValues) => {
        return (
          <Tooltip title="View">
            <IconButton
              color="primary"
              onClick={() => onViewDetails(cellValues)}
            >
              <ViewIcon />
            </IconButton>
          </Tooltip>
        );
      }
    },
  ];

  const viewdownloadDocument = (documentBlobName, finalfileName, type) => {
    loaderService.showLoader();
    return fetch(DOWNLOAD_DOCUMENT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        AuthKey: authKey,
      },
      body: JSON.stringify({
        "fileName": documentBlobName,
        "containerName": "pit",
        "file": ""
      })
    })
      .then((response) => response.blob())
      .then((blob) => {
        if (type === "View") {
          const fileName = finalfileName || "";
          const splittedName = fileName.split('.');
          const fileExtension = splittedName[splittedName.length - 1]?.toLowerCase();
          let fileType;
          switch (fileExtension) {
            case 'pdf':
              fileType = 'application/pdf';
              break;
            case 'png':
              fileType = 'image/png';
              break;
            case 'jpg':
            case 'jpeg':
              fileType = 'image/jpeg';
              break;
            default:
              fileType = 'application/octet-stream';
          }
          const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
          const newWindow = window.open(url, '_blank');
          if (newWindow) newWindow.focus();
        }
        else {
          const a = document.createElement("a");
          a.style.display = "none";
          document.body.appendChild(a);
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = finalfileName;
          a.click();
          window.URL.revokeObjectURL(url);
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  };

  const columns1 = [
    { field: 'sesNo', headerName: 'SES No', width: 120 },
    { field: 'invoiceNo', headerName: 'Invoice No', width: 120 },
    { field: 'sesStakeholderType', headerName: 'SES Stakeholder Type', width: 170 },
    { field: 'sesType', headerName: 'Material Type', width: 150 },
    {
      field: 'sesDate', headerName: 'SES Date', width: 120,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
    },
    { field: 'pickupTotalWeight', headerName: 'PickUp Quantity (MT)', width: 170 },
    { field: 'destinationTotalWeight', headerName: 'Unloading Quantity (MT)', width: 190 },
    { field: 'approvedBy', headerName: 'Approved By', width: 200 },
    { field: 'sesQuantity', headerName: 'SES Quantity (MT)', width: 140 },
    {
      field: 'invoiceAmount', headerName: 'SES Amount(in Rs)', width: 150,
      valueGetter: (params) => {
        return Number(params?.value).toFixed(4);

      }
      // valueFormatter: () => "MT"
    },
    { field: 'poNumber', headerName: 'PO Number', width: 160 },
    { field: 'sapPoNumber', headerName: 'SAP Po Number', width: 160 },
    { field: 'sapSesNumber', headerName: 'SAP SES Number', width: 200, hide: tabValue !== 'sent_sap' },
    {
      field: 'invoiceDocuments',
      headerName: "Invoice Documents",
      width: 260,
      renderCell: (params) => {
        const docs = params.value || [];
        if (!docs || docs.length === 0) return <Typography variant="caption">No Documents</Typography>;
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, py: 0.5 }}>
            {docs.map((doc, idx) => (
              <Box key={doc.invoiceFileId || idx} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Link
                  component="button"
                  variant="body2"
                  onClick={(e) => {
                    e.preventDefault();
                    viewdownloadDocument(doc?.invoiceFileId, doc?.invoiceFileName, "View");
                  }}
                  underline="hover"
                  sx={{ cursor: 'pointer', fontSize: '0.8rem' }}
                >
                  {doc.invoiceFileName}
                </Link>
                <Button
                  size="small"
                  variant="text"
                  onClick={() => viewdownloadDocument(doc?.invoiceFileId, doc?.invoiceFileName, "Download")}
                  sx={{ minWidth: 'auto', p: 0, fontSize: '0.7rem', textTransform: 'none' }}
                >
                  Download
                </Button>
              </Box>
            ))}
          </Box>
        );
      }
    },
    {
      field: 'Action', width: 100,
      renderCell: (cellValues) => {
        return (
          <Tooltip title="View">
            <IconButton
              color="primary"
              onClick={() => onViewDetails(cellValues)}
            >
              <ViewIcon />
            </IconButton>
          </Tooltip>
        );
      }
    },
  ];

  const onConfirmApprove = (e) => {
    handleConfirmClose();
    onApprove(e);
  }

  const onApproveButtonClick = (e) => {
    handleConfirmOpen();
  }

  const onApprove = (e) => {
    if (sesList.length < 1) {
      setErrorMessage({ ...errorMessage, noRecordError: "Please select at least one SES to approve" });
    }
    else {
      setErrorMessage({ ...errorMessage, noRecordError: "" });
      toApproveBulk(true);
    }
  }

  const toApproveBulk = (e) => {
    loaderService.showLoader();
    apiClient
      .post(BULK_APPROVE_SES,
        {
          "sesNoList": sesList,
          "approvedBy": accountName
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setBulkApproveSes(response.data);
        getSesList();
        loaderService.hideLoader();
        setsesList([]);
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const onConfirmSapApprove = () => {
    handleConfirmSapClose();
    toSendToSAP();
  }

  const toSendToSAP = () => {
    loaderService.showLoader();
    apiClient
      .post(SEND_SES_TO_SAP,
        {
          "sesNoList": sesList,
          "approvedBy": ""
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        if (response.data?.isSuccess || response.data?.success) {
          toast.success(response.data?.message || "Successfully sent to SAP");
        } else {
          toast.error(response.data?.message || "Successfully sent to SAP");
        }
        getSesList();
        loaderService.hideLoader();
        setsesList([]);
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  useEffect(() => {
    if (bulkApproveSes) {
      if (bulkApproveSes.isSuccess === true) {
        toast.success(bulkApproveSes?.message)
        // handleLogModalOpen2();
      }
      else {
        toast.error(bulkApproveSes?.message ? bulkApproveSes?.message : "Error")
        // handleLogModalOpen();
      }
    }
  }, [bulkApproveSes]);

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT44</p>}
        <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            SES Approval
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
            <>
              <Stack direction="row" spacing={1}>
                {tabValue === "false" && (
                  <Button variant="contained" disabled={sesList?.length < 1} onClick={(e) => onApproveButtonClick(e)} startIcon={<ApproveIcon />}>
                    Approve
                  </Button>
                )}
                {tabValue === "ready_sap" && (
                  <Button variant="contained" disabled={sesList?.length < 1} onClick={handleConfirmSapOpen} startIcon={<SendIcon />}>
                    Send to SAP
                  </Button>
                )}
              </Stack>
            </>
          </Stack>
        </Stack>
        <Card>
          <TabContext value={tabValue} style={{ marginLeft: "1.5vh" }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'whitesmoke' }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                <Tab label="SES Approval List" value="false" />
                <Tab label="SES Approved List" value="true" />
                <Tab label="Ready to send to SAP" value="ready_sap" />
                <Tab label="Sent to SAP" value="sent_sap" />
              </TabList>
            </Box>
            <TabPanel value="false">
              <Box style={{ height: 445, width: '100%' }}>
                {
                  grnListData &&
                  <DataGrid rows={grnListData}
                    columns={columns}
                    pageSize={10}
                    checkboxSelection
                    components={{ Toolbar: QuickSearchToolbar }}
                    onSelectionModelChange={(newSelection) => {

                      setsesList(newSelection.map(row => {
                        let sNo = ""
                        grnListData.forEach(ses => {

                          if (row === ses.id) {
                            sNo = ses.sesNo;
                          }

                        })
                        return sNo;
                      }));
                    }}
                  />
                }
              </Box>
            </TabPanel>

            <TabPanel value="true">
              <Box style={{ height: 445, width: '100%' }}>
                {
                  grnListData &&
                  <DataGrid rows={grnListData}
                    columns={columns1}
                    pageSize={10}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />
                }
              </Box>
            </TabPanel>

            <TabPanel value="ready_sap">
              <Box style={{ height: 445, width: '100%' }}>
                {
                  grnListData &&
                  <DataGrid rows={grnListData}
                    columns={columns1}
                    pageSize={10}
                    checkboxSelection
                    components={{ Toolbar: QuickSearchToolbar }}
                    onSelectionModelChange={(newSelection) => {
                      setsesList(newSelection.map(row => {
                        let sNo = ""
                        grnListData.forEach(ses => {
                          if (row === ses.id) {
                            sNo = ses.sesNo;
                          }
                        })
                        return sNo;
                      }));
                    }}
                  />
                }
              </Box>
            </TabPanel>

            <TabPanel value="sent_sap">
              <Box style={{ height: 445, width: '100%' }}>
                {
                  grnListData &&
                  <DataGrid rows={grnListData}
                    columns={columns1}
                    pageSize={10}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />
                }
              </Box>
            </TabPanel>

          </TabContext>

        </Card>

      </Container>

      <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Approve" />

      <ConfirmationPopover onOpen={confirmSapOpen} onConfirm={onConfirmSapApprove} onClose={handleConfirmSapClose} action="Send to SAP" />

      <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
          <ErrorPopover title={"ERROR"} navigate={navigate} goToStakeHolderDashboard="goToStakeHolderDashboard" hideLink={true} />
        </DialogContent>

      </Dialog>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
        <DialogContent>
          <ConfirmPopover title={bulkApproveSes?.message ? bulkApproveSes?.message : "Error"} hideLink={true} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose2}>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default SESApproval;
